<template>
  <div class="">
    <div class="head-title">客户标签</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>1、企业根据业务需求，创建或删除企业客户标签及标签组。</p>
          <p>
            2、员工在与客户沟通中，既可以选择企业创建的标签，也可以选择个人标签给客户打标签分类，同时也是客户管理中标签设置的选择。
          </p>
          <p>3、支持同步企业微信标签。</p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <nav class="navbar">
        <div class="nav-l">
          <span class="shij">
            <el-button
              @click="onSubmit = true"
              icon="el-icon-plus"
              type="primary"
              >添加</el-button
            >
          </span>
          <span class="shij">
            <el-button @click="tongbu" type="primary" icon="el-icon-refresh"
              >同步企业标签</el-button
            >
          </span>
        </div>
        <div class="nav-r">
          <el-input
            clearable
            placeholder="请输入标签组搜索"
            style="width: 35.0rem; "
            prefix-icon="el-icon-search"
            v-model="input2"
            @change="rune()"
          >
          <el-button slot="append" @click="rune()" type="primary"
            >查询</el-button
          >
          </el-input>

        </div>
      </nav>
      <div style="width: 100%; margin-top: 2.0rem">
        <el-table
          border
          :data="tableData.data"
          v-loading="tableLoading"
        >
          <el-table-column
            prop="group_name"
            label="标签组"
            style="width: 10%"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="tag_name"
            label="标签"
            style="width: 20%"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                size="mini"
                style="margin: .2rem"
                v-for="t in scope.row.tags"
                :key="t"
                >{{ t }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="300">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="
                  (onSubmitn = true),
                    bianji(scope.row.group_id, scope.row.group_name)
                "
                >新增标签</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click="(onEdit = true), getListOne(scope.row.group_id)"
              >
                编辑
              </el-button>
              <el-button
                size="mini"
                type="text"
                @click="handleClick(scope.row.group_id)"
                style="color: #f00000 !important;"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging">
        <pagination
          :total="tableData.total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          :auto-scroll="false"
          @pagination="userTable"
        />
      </div>
    </div>
    <el-dialog title="添加" center :visible.sync="onSubmit" width="30%">
      <el-form ref="form" :model="form" :rules="rules" label-width="8.0rem">
        <el-form-item label="分组名称" prop="group_name">
          <el-input
            clearable
            v-model="form.group_name"
            placeholder="请输入分组名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="标签" prop="tag_name">
          <el-input
            clearable
            v-model="form.tag_name"
            placeholder="请输入标签名称，多标签请用逗号(,)分隔"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit = false">取 消</el-button>
        <el-button type="primary" @click="numoo()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="新增标签" center :visible.sync="onSubmitn" width="30%">
      <el-form ref="form" :model="form" :rules="rules" label-width="8.0rem">
        <el-form-item label="标签名称" prop="name">
          <el-input clearable v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitn = false">取 消</el-button>
        <el-button type="primary" @click="numoon()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑标签" center :visible.sync="onEdit" width="30%">
      <el-form ref="formE" :model="formE" :rules="rules" label-width="10.0rem">
        <el-form-item label="标签组名称" prop="group_name">
          <el-input
            clearable
            v-model="formE.group_name"
            placeholder="请输入标签组名称"
          ></el-input>
        </el-form-item>
        <div v-for="(i, index) in formE.group_arr" :key="index">
          <el-form-item label="标签" prop="group_arr" class="tag">
            <el-input
              clearable
              v-model="formE.group_arr[index].tag_name"
              placeholder="请输入标签名称"
            >
            </el-input>
            <i
              class="el-icon-error icon"
              @click="delTag(formE.group_arr[index].tag_id)"
            ></i>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onEdit = false">取 消</el-button>
        <el-button type="primary" @click="editTag()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
export default {
  name: "monitoring",
  components: {
    Pagination,
  },
  data() {
    return {
      tableData: {
        data: [],
        total: 0,
      },
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      tableData_a: [],
      multipleSelection: [],
      value1: true,
      form: {
        name: "",
        group_name: "",
        tag_name: "",
      },
      ele: "",
      g_name: "",
      yeshu: 1,
      bianjile: "",
      pageSize: "",
      rules: {
        name: [{ required: true, message: "请输入新增名称", trigger: "blur" }],
        group_name: [
          { required: true, message: "请输入分组名称", trigger: "blur" },
        ],
        tag_name: [{ required: true, message: "请输入标签", trigger: "blur" }],
      },
      listQuery: {
        page: 1,
        limit: 20,
      },
      onEdit: false,
      formE: {
        group_name: "",
        group_arr: [],
        group_id: "",
      },
      tableLoading: true,
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.userTable();
    //console.log(this.tableData.data,"tabledata.data")
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    tongbu() {
      this.axios
        .post(
          "/crm/Assistant/get_tag",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.userTable();
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    userTable() {
      this.axios
        .post(
          "/crm/Assistant/getLabelList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            group_name: this.input2,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tableLoading = false;
          this.tableData = res.data.data;
          res.data.data.data.forEach((i) => {
            const regex = /，|,/gim;
            const tags = i.tag_name.replace(regex, ",");
            i.tags = tags.split(",");
          });

        })
        .catch(function (err) {});
    },
    rune() {
      this.userTable();
    },

    handleSelectionChange(val) {
      this.yeshu = 1;
      this.multipleSelection = val;
    },
    //打开 新增时
    bianji(e, n) {

      this.ele = e; //分组id
      this.g_name = n; //分组名称
      this.form.name="";//之前遗留的name 清空
    },
    // 新增标签确认
    numoon() {
      /*标签名称不能为空 或 空格*/
      if(this.form.name.trim()==""){
          this.$message({
          message:'名称或标签不能为空',
          type:"info",
        })
        return
      }

      this.axios
        .post(
          "/crm/Assistant/addLabel",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            tag_name: this.form.name,
            group_id: this.ele,
            group_name: this.g_name,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.userTable();
            this.form.name="";//之前遗留的name 清空

          } else if (res.data.code == 0) {
            if(res.data.data.errcode == 40071){
              this.$message.error('与已存在标签重复');
              return
            }
            if(res.data.data.errcode == 40068||res.data.data.errcode == 40081){
              this.$message.error('无权限');
              return
            }
            this.onSubmitn = true;
            this.$message.error(res.data.msg);

          }
        })
        .catch(function (err) {});
    },
    // 添加
    numoo() {
      if(this.form.group_name.trim()==""){
        this.$message({
              message: '名称或标签不能为空',
              type: "info",
            });
            return;
      }
      if(this.form.group_name.length > 12){
        this.$message({
              message: '名称或标签不能超过12个字符',
              type: "info",
            });
            return;
        }
      if( this.form.tag_name.trim()==""){
        this.$message({
              message: '名称或标签不能为空',
              type: "info",
            });
            return;
      }
      if(this.form.tag_name.length > 12){
        this.$message({
              message: '名称或标签不能超过12个字符',
              type: "info",
            });
            return;
        }
      this.axios
        .post(
          "/crm/Assistant/addLabel",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            group_name: this.form.group_name,
            tag_name: this.form.tag_name,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.form.tag_name = ''
            this.form.group_name = ''
            this.userTable();
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);

          }
        })
        .catch(function (err) {});
    },
    // 移除
    handleClick(e) {
      //console.log(this, 22);
      this.yeshu = 1;
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/Assistant/delLabelSet",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
                group_id: e,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message({
            message: "已取消删除",
            type: "info",
          });
        });
    },
    //编辑
    getListOne(e) {
      console.log("编辑getListOne")
      this.axios
        .post(
          "/crm/Assistant/getLabelListOne",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            group_id: e,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            let d = res.data.data;
            this.formE.group_id = d.group_id;
            this.formE.group_name = d.group_name;
            this.formE.group_arr = d.tagArr;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    editTag() {
      console.log("编辑editTag")
      let tags = JSON.stringify(this.formE.group_arr);
      /*标签组的名称不能为空 或 空格*/
      if(this.formE.group_name.trim()==""){
          this.$message({
          message:'名称或标签不能为空',
          type:"info",
        })
        return
      }
      if(this.formE.group_name.length > 12){
        this.$message({
              message: '名称或标签不能超过12个字符',
              type: "info",
            });
            return;
        }
      if(this.formE.group_name!=""){
        for(let item of this.formE.group_arr){
          if(item.tag_name.trim()==""){
          this.$message({
          message:'名称或标签不能为空',
          type:"info",
        })
        return
        }
        if(item.tag_name.length > 12){
        this.$message({
              message: '名称或标签不能超过12个字符',
              type: "info",
            });
            return;
        }
        }
      }
      this.axios
        .post(
          "/crm/Assistant/editLabel",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            group_id: this.formE.group_id,
            group_name: this.formE.group_name,
            tagArr: tags,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          }
          this.onEdit = false;
          this.userTable();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    delTag(e) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let id = e;
          let ind = this.formE.group_arr.findIndex((i) => {
            return i.tag_id == id;
          });
          let arr = this.formE.group_arr.splice(ind, 1);
          this.axios
            .post(
              "/crm/Assistant/delLabelSet",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                tag_id: arr[0].tag_id,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              }
              this.userTable();
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            message: "已取消删除",
            type: "info",
          });
        });
    },
  },
};
</script>
<style scoped>
.hello {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}
nav {
  width: 100%;
}
.shij {
  display: inline-block;
  margin-right: 2.4rem;
}
.navbar {
  display: flex;
  justify-content: space-between;
}
.tag ::v-deep.el-form-item__content {
  display: flex;
  align-items: center;
}
.icon {
  margin-left: 1.0rem;
  font-size: 2.0rem;
  cursor: pointer;
}
.el-button--text{padding-left:.0rem !important;}
</style>
